import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
//styles
import './cart.scss';
//translations
import { useTranslation } from 'react-i18next';
//redux
import { useSelector, useDispatch } from 'react-redux';
import {
  setShippingAddress,
  setPickUpLibrary,
  userSelector,
} from 'slices/user';
import { companySelector } from 'slices/company';
import {
  cartSelector,
  setIsStorePickup,
  setShippingFee,
  setShippingCartAddress,
} from 'slices/cart';
// Utils-Redux
import { calculateShippingCosts } from 'components/cart/utils';
//api
import { saveChanges } from 'api/users';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import { InputCustom } from 'components/input';
import OrderSummary from 'components/cart/OrderSummary';
import OrderStepper from 'components/cart/OrderStepper';
import CustomTab from 'components/Tab';
import LoginComp from 'components/login/LoginComp';
import RegisterComp from 'components/register/RegisterComp';
import AddressForm from 'components/addressForm';
import OrderPickup from 'components/cart/OrderPickup';
//helpers
import { goUp } from 'helpers';

const Shipping = () => {
  const { t } = useTranslation(['shipping', 'backoffice']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { assignedLibrary} = useAssignedLibrary();

  const {
    name: empresa,
    id: bookstoreId,
    enabled_countries,
    shipping_cost,
    min_purchase_for_free_shipping,
  } = useSelector(companySelector);

  const {
    isLogged,
    shippingAddress,
    firstName,
    lastName,
    email,
    phoneNumber,
    id,
  } = useSelector(userSelector);
  const {
    countItems,
    total,
    isShippingAvailable,
    shippingCosts,
    errorAmountPrice,
    isStorePickup,
    contactInfo
  } = useSelector(cartSelector);

  const [addDirection, setAddDirection] = useState(false);

  const [isGift, setIsGift] = useState(false);

  const [validData, setValidData] = useState([false, t('completeFields')]);

  const [giftInfo, setGiftInfo] = useState({
    email: '',
    name: '',
    surname: '',
    message: '',
  });

  const initialShippingValue = () => {
    if (shippingAddress) {
      return {
        ...shippingAddress,
        email: email || '',
        first_name: firstName || '',
        last_name: lastName || '',
        phone: shippingAddress.phone || phoneNumber || '',
      };
    } else {
      return {
        address: '',
        postal_code: '',
        first_name: firstName || '',
        last_name: lastName || '',
        locality: '',
        province: '',
        country: '',
        email: email || '',
        phone: phoneNumber || '',
      };
    }
  };

  const [updateDataShipping, setUpdateDataShipping] = useState(() => initialShippingValue());

  useEffect(() => {
    window.document.title = 'Carrito de compras | ' + empresa;
    !countItems && navigate('/');
    goUp();
    dispatch(setIsStorePickup(false));
    dispatch(setPickUpLibrary(null));
    dispatch(setShippingCartAddress(updateDataShipping));
    dispatch(setShippingFee(shipping_cost));
  }, []);

  useEffect(() => {
    const calculatedShipping = calculateShippingCosts(shippingCosts, min_purchase_for_free_shipping, total);
    total && dispatch(setShippingFee(calculatedShipping));
  }, [total, shippingCosts]);

 

  const checkData = (updatingAddressToCheck) => {
    if (updatingAddressToCheck !== undefined) {
      let properties = ['first_name', 'address', 'postal_code', 'locality', 'phone'];
      for (let i of properties) {
        if (updatingAddressToCheck[`${i}`] === undefined || updatingAddressToCheck[`${i}`] === '') {
          setValidData([false, t('completeFields')]);
          return '';
        }
      }
      setValidData([
        true,
        updatingAddressToCheck.address + ', ' + updatingAddressToCheck.postal_code + ', ' + updatingAddressToCheck.locality
      ]);
    }
  };

  useEffect(() => {
    isLogged && checkData(updateDataShipping);
  }, [updateDataShipping]);

  const handleChangeSave = async (values) => {
    let payload = {
      first_name: values?.first_name,
      last_name: values?.last_name,
      email: values?.email,
      phone: values?.phone,
      address: values?.address,
      country: values?.country,
      province: values?.province?.label || '',
      locality: values?.locality,
      postal_code: values?.postal_code,
    };
    try {
      const changes = await saveChanges({ shipping_address: payload }, id);
      if (changes.status === 200) {
        dispatch(setShippingAddress(payload));
        setAddDirection(false)
      }
    } catch (error) {
      console.error(error)
    }
  };

  const handleTabChange = (key) => {
    if (key === 'homeDelivery') {
      dispatch(setIsStorePickup(false));
      dispatch(setPickUpLibrary(null));
      dispatch(setShippingFee(shipping_cost));
    } else if (key === 'storePickup') {
      dispatch(setIsStorePickup(true));
      dispatch(setPickUpLibrary(bookstoreId));
      dispatch(setShippingFee(0));
    }
  };

  const disableNext = () => {
    if (!isLogged || !isShippingAvailable?.availability || errorAmountPrice || !validData[0]) {
      return true;
    }
    return false;
  };

  return (
    <Container fluid className="sm-fluid mainDiv">
      <Row className="justify-content-center">
        <Col md={9}>
          <OrderStepper activeStep={1} />

          {isLogged ? (
            <>
              {isGift && (
                <>
                  <div>
                    <h2 onClick={() => console.log(giftInfo)} className="mt-3">
                      {t('recipientData')}
                    </h2>
                    <div className="giftDiv">
                      <Row>
                        <Col md={6} lg={6} xs={6} >
                          <p className="mb-0">{t('recipientName')}</p>
                          <InputCustom
                            onChange={(e) => {
                              return setGiftInfo({
                                ...giftInfo,
                                name: e.target.value,
                              });
                            }}
                            type="text"
                          />
                        </Col>
                        <Col md={6} lg={6} xs={6}>
                          <p className="mb-0">{t('recipientLastName')}</p>
                          <InputCustom
                            onChange={(e) => {
                              return setGiftInfo({
                                ...giftInfo,
                                surname: e.target.value,
                              });
                            }}
                            type="text"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} lg={12} xs={12}>
                          <p className="mb-0">{t('recipientEmail')}</p>
                          <InputCustom
                            onChange={(e) => {
                              return setGiftInfo({
                                ...giftInfo,
                                email: e.target.value,
                              });
                            }}
                            type="text"
                          />
                          <p className="mb-0">Mensaje</p>
                          <InputCustom
                            onChange={(e) => {
                              return setGiftInfo({
                                ...giftInfo,
                                message: e.target.value,
                              });
                            }}
                            type="textarea"
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <p className="textInfo mt-4">{t('contactDataUseWarning')}</p>
                  <p className="textInfo my-4">
                    {t('giftNotification')}
                    <Link to={`/${assignedLibrary}/faqs`}>{t('faq')}</Link> {t('our')}
                    <Link to={`/${assignedLibrary}/aviso-legal-y-politica-de-privacidad`}>{t('dataPrivacyPolicy')}</Link> {t('or')}
                    <Link to={`/${assignedLibrary}/contacto`}>{t('contactUs')}</Link>
                  </p>
                </>
              )}

              <Row className="tabs-row">
                <Col md={12} lg={12} xs={12} className="ml-1">
                  <h2 className="mt-3">{t('deliveryMethod')}</h2>

                  <CustomTab
                    customClass="custom-tab"
                    onSelect={handleTabChange}
                    tabs={[
                      {
                        title: t('homeDelivery'),
                        id: 'homeDelivery',
                        renderContent: () => {
                          return !addDirection ? (
                            <Col lg={12} className="mt-2 d-flex justify-content-center">
                              <Row className="mt-2 w-100 d-flex justify-content-center">
                                <Col lg={8} md={8} sm={12} xs={12} className="mb-3 mb-md-0">
                                  <Form.Control value={validData[1]} disabled className={`${disableNext() && 'border-danger text-danger'}`} />
                                </Col>
                                <Col lg={4} md={4} sm={12} xs={12} className="d-flex justify-content-center">
                                  <Button className="white-btn" onClick={() => setAddDirection(!addDirection)}>
                                    {t('editAddress').toUpperCase()}
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          ) : (
                            <AddressForm
                              data={updateDataShipping}
                              onChange={(newData) => {
                                setUpdateDataShipping(newData);
                                dispatch(setShippingCartAddress(newData));
                              }}
                              onCancel={() => {
                                setUpdateDataShipping(shippingAddress); //! VALORES INIC DE REDUX
                                dispatch(setShippingCartAddress(shippingAddress));
                                setAddDirection(false)
                              }}
                              onSave={() => handleChangeSave(updateDataShipping)}
                              countries={enabled_countries}
                              additionalInfoHeader={t('addressAndDeliveryData')}
                              isShippingAddressDetails={true}
                            />
                          );
                        },
                      },
                      { title: t('storePickup'), id: 'storePickup', renderContent: () => <OrderPickup /> },
                    ]}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <Row className="tabs-row mt-3">
              <Col md={12} lg={12} xs={12}>
                <h2 className="my-3">
                  {t('areYouUserOf')} {empresa}?
                </h2>

                <CustomTab
                  customClass="custom-tab "
                  onSelect={handleTabChange}
                  tabs={[
                    { title: t('login'), id: 'login', renderContent: () => <LoginComp fromCarro={true} /> },
                    { title: t('register'), id: 'register', renderContent: () => (
                      <div className="m-3">
                        <RegisterComp /> 
                      </div>)},
                  ]}
                />

                {isGift && (
                  <>
                    <div>
                      <h2 className="mt-3">{t('recipientData')}</h2>
                      <div className="giftDiv">
                        <Row>
                          <Col md={6} lg={6} xs={6}>
                            <p className="mb-0">{t('recipientName')}</p>
                            <InputCustom type="text" />
                          </Col>
                          <Col md={6} lg={6} xs={6}>
                            <p className="mb-0">{t('recipientLastName')}</p>
                            <InputCustom type="text" />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12} lg={12} xs={12}>
                            <p className="mb-0">{t('recipientEmail')}</p>
                            <InputCustom type="text" />
                            <p className="mb-0">{t('message')}</p>
                            <InputCustom as="textarea" />
                          </Col>
                        </Row>
                      </div>
                    </div>

                    <p className="textInfo mt-4">{t('contactDataUseWarning')}</p>
                    <p className="textInfo my-4">
                      {t('giftNotification')}
                      <Link to={`/${assignedLibrary}/faqs`}> {t('faq')}</Link> {t('our')}
                      <Link to={`/${assignedLibrary}/aviso-legal-y-politica-de-privacidad`}>{t('dataPrivacyPolicy')}</Link> {t('or')}
                      <Link to={`/${assignedLibrary}/contacto`}> {t('contactUs')}</Link>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          )}

          <Row className="discount mt-5">
            <Col md={12} lg={12} xs={12} className="d-flex justify-content-between">
              <span>
                <Button
                  className="orange-btn ml-3 p-2 text-white"
                  as={Link}
                  to={{ pathname: `/${assignedLibrary}/carrito` }}
                  size="sm"
                >
                  {t('goBack').toUpperCase()}
                </Button>
              </span>
              <span>
                <p className="pt-2 d-inline mx-3">{t('nextPay')}</p>
                {(disableNext() && !isStorePickup) || (isStorePickup && contactInfo.email_phone === '') ?
                  <OverlayTrigger
                    overlay={<Tooltip id="button-tooltip">{t('completeFields')}</Tooltip>}
                  >
                    <span className="d-inline-block">
                      <Button
                        className='orange-btn ml-3 p-2 disabled'
                        as={Link}
                        to="#"
                        disabled
                      >
                        {t('continue').toUpperCase()}
                      </Button>
                    </span>
                  </OverlayTrigger> :
                  <Button
                    className='orange-btn ml-3 p-2'
                    // onClick={() => {
                    //   if (!isLogged) {
                    //     registerUser();
                    //   }
                    //   return dispatch(setGiftData(giftInfo));
                    // }}
                    as={Link}
                    to={`/${assignedLibrary}/pago`}
                  >
                    {t('continue').toUpperCase()}
                  </Button>}
              </span>
            </Col>
          </Row>
          <p className="my-4">
            {t('anyDoubts')}
            <Link to={`/${assignedLibrary}/faqs`}> {t('faq')}</Link> {t('or')}
            <Link to={`/${assignedLibrary}/contacto`}> {t('contactUs')}</Link>
          </p>
          <p className="textInfo m-0">{t('formFullfilmentResponsability')}</p>
          <p className="textInfo">
            {t('readPrivacyPolicy')} {empresa}
            <Link to={`/${assignedLibrary}/aviso-legal-y-politica-de-privacidad`}> {t('here')}</Link>.
          </p>
        </Col>

        {total && <OrderSummary activeStep={1} />}
      </Row>
    </Container>
  );
};

export default Shipping;